<template>
  <div :class="$style.container">
    <div :class="$pgCTStyle.headerContainer">
      <div :class="[$pgCTStyle.title, $style.title]">  {{
    moderatorPlayers.length > 1
      ? `${$t("players")} & ${$t("moderators")}`
      : $t("players")
  }}</div>
      <div :class="$pgCTStyle.currentCount">
        {{ displayTotalPlayers  }}
      </div>
    </div>
    <div
      v-if="phase === 'JOIN' && players.length > 0 && displayGroups.length > 1"
      :class="$style.emptyStateText"
    >
      {{ $t("drag-players-between-groups") }}
    </div>
    <div v-if="players.length === 0" :class="$style.emptyStateText">
      {{ $t("waiting-for-players") }}
    </div>
    <div :class="$pgCTStyle.bodyContainer">
    <div
        v-if="showModeratorSection && players.length > 1"
        :class="[
          $style.group,
          dragOverModerator
            ? $style.groupDropActive
            : ''
        ]"
        @dragover.prevent="dragOverModerator = true"
        @dragleave.self="dragOverModerator = false"
        @drop.prevent.stop="handleModeratorDrop"
      >
      <div :class="$style.groupHeader">
        <div>
          <div :class="$style.groupName">
            {{ $t("moderators") }}
          </div>
        </div>

        <div :class="$style.currentGroupCount">
          {{ moderatorPlayers.length }}
        </div>
      </div>
      <div
        v-for="player in moderatorPlayers"
        :key="player.id"
        :class="[
          $style.groupPlayers,
          phase === 'JOIN' ? $style.draggable : '',
          isDraggingPlayer(player.id) ? $style.draggingPlayer : ''
        ]"
        :draggable="phase === 'JOIN'"
        @dragstart="phase === 'JOIN' && handleModeratorDragStart(player)"
        @dragend="handleDragEnd"
      >
        <div :class="$style.player">
          <div :class="$style.avatarBox">
            <img
              :src="player.avatar || defaultAvatar"
              alt="Avatar"
              :class="$style.avatar"
            />
          </div>

          <div :class="$style.nameRow">
            <div :class="$style.name">
              {{ player.username }}
            </div>

            <template>
              <div :class="$style.moderatorChip">
                {{ $t("moderator") }}
              </div>
            </template>
          </div>

          <div
                v-if="phase === 'JOIN'"
                :class="$style.moderatorButton"
                style="margin-left: auto; display: flex; gap: 6px;"
                @mousedown.stop
                @dragstart.stop
          >
            <PGHeaderActionButton
              :clickFunction="() => toggleModeratorAllGroups(player.id)"
              :iconLink="DetectiveHatIcon"
              iconOnly
              variant="primary"
              frontBg="#ffd54f"
              backBg="#e6b800"
              :ariaLabel="$t('demote')"
              :title="$t('demote')"
              iconSize="10px"
              buttonWidth="20px"
              buttonHeight="20px"
            />
          </div>
        </div>
      </div>
      <div
        v-if="moderatorPlayers.length === 0 "
        :class="$style.emptyStateText"
      >
        {{ $t("drag-moderators-here") }}
      </div>
      </div>
      <div
        v-for="(group, groupIndex) in displayGroups"
        :key="group.id || groupIndex"
        :class="[
          $style.group,
          phase !== 'JOIN' ? $style.compactGroup : '',
          phase === 'JOIN' && dragOverGroupIndex === groupIndex
          ? $style.groupDropActive
          : '',
        ]"
       @dragover.prevent="phase === 'JOIN' && (dragOverGroupIndex = groupIndex)"
        @dragleave="handleGroupLeave"
        @drop="phase === 'JOIN' && handleGroupDrop(groupIndex)"
      >
        <div :class="$style.groupHeader">
          <div>
            <div :class="$style.groupName">{{ group.name }}</div>
          </div>
          <div :class="$style.currentGroupCount">
            {{ displayPlayersCount(groupIndex) }}<span v-if="phase === 'JOIN'"  :class="$style.votesAvailable">/{{ groupLimit }}</span>
          </div>
        </div>
          <div
            v-for="(player, playerIndex) in displayPlayers(groupIndex)"
            :key="player.id"
            :class="[
              $style.groupPlayers,
              isModerator(groupIndex, player.id) ? $style.moderatorRow : '',
              phase === 'JOIN' ? $style.draggable : '',
              isDraggingPlayer(player.id) ? $style.draggingPlayer : ''
            ]"
            :draggable="phase === 'JOIN'"
            @dragstart="phase === 'JOIN' && handleDragStart(groupIndex, player)"
            @dragend="handleDragEnd"
            @dragover.prevent="
              phase === 'JOIN' && (
                dragOverGroupIndex = groupIndex
              )
            "
            @drop.stop="phase === 'JOIN' && handlePlayerDrop(groupIndex, playerIndex)"
          >
          <div :class="$style.player">
            <div :class="$style.avatarBox">
              <img
                :src="player.avatar || defaultAvatar"
                alt="Avatar"
                :class="$style.avatar"
              />
            </div>

            <div :class="$style.nameRow">
              <div :class="$style.name">{{ player.username }}</div>

              <!-- SHOW CHIP BESIDE NAME (except JOIN + REVEAL) -->
              <template v-if="!['JOIN', 'REVEAL'].includes(phase)">
                <div
                  v-if="Number(player.id) === Number(hostId)"
                  :class="$style.hostChip"
                >
                  {{ $t('host') }}
                </div>

                <div
                  v-else-if="isModeratorAnywhere(player.id)"
                  :class="$style.moderatorChip"
                >
                  {{ $t("moderator") }}
                </div>
              </template>

              <!-- FALLBACK (below name in JOIN / REVEAL) -->
              <template v-else>
                <div style="display: flex; flex-direction: column;">
                  <div
                    v-if="Number(player.id) === Number(hostId)"
                    :class="$style.hostChip"
                  >
                    {{ $t('host') }}
                  </div>

                  <div
                    v-else-if="isModeratorAnywhere(player.id)"
                    :class="$style.moderatorChip"
                  >
                    {{ $t("moderator") }}
                  </div>
                </div>
              </template>
            </div>
              <div
                v-if="phase === 'JOIN' && !isPlayerModerator(player.id)"
                :class="$style.moderatorButton"
                style="margin-left: auto; display: flex; gap: 6px;"
                @mousedown.stop
                @dragstart.stop
              >
              <PGHeaderActionButton
                :clickFunction="() => toggleModeratorAllGroups(player.id)"
                :iconLink="getModeratorButtonIcon(player.id)"
                iconOnly
                variant="primary"
                :frontBg="
                  isModeratorAnywhere(player.id)
                    ? '#ffd54f'
                    : '#e0e0e0'
                "
                :backBg="
                  isModeratorAnywhere(player.id)
                    ? '#e6b800'
                    : '#c2c2c2'
                "
                :ariaLabel="$t('promote')"
                :title="$t('promote')"
                iconSize="10px"
                buttonWidth="20px"
                buttonHeight="20px"
              />
          </div>
        </div>
      </div>

        <div
          v-if="phase === 'JOIN' && displayPlayers(groupIndex).length === 0"
          :class="[
            $style.emptyStateText
          ]"
          @dragover.prevent="phase === 'JOIN' && (dragOverGroupIndex = groupIndex)"
          @dragleave="dragOverGroupIndex = null"
          @drop.stop="phase === 'JOIN' && handleGroupDrop(groupIndex)"
        >
          {{ $t("drag-players-here") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defaultAvatar } from "@/utils/data";
import styles from "@/css/GroupedPlayersBox.module.css";
import playGameComponentsTemplateStyles from "@/css/PlayGameComponentsTemplate.module.css";
import PGHeaderActionButton from "../buttons/PGHeaderActionButton.vue";
import DetectiveHatIcon from "@/assets/icons/detective-hat.svg";
import UserIcon from "@/assets/icons/user.svg";

export default {
  name: "GroupedPlayersBox",
  components: {
    PGHeaderActionButton,
  },
  props: {
    phase: {
      type: String,
      required: true,
    },
    players: {
      type: Array,
      required: true,
    },
    pendingModerators: {
      type: Object,
      required: true,
    },
    allowedPlayers: {
      type: Number,
      required: true,
    },
    groupLimit: {
      type: Number,
      required: true,
    },
    groups: {
      type: Array,
      required: true,
    },
    hostId: {
      type: Number,
      required: false,
      default: null,
    },
    isModeratorView: {
      type: Boolean,
      default: false
    },
  },
  emits: ["update:groups", "update:moderators"],
  data() {
    return {
      defaultAvatar,
      localGroups: [],
      dragState: {
        sourceGroupIndex: null,
        sourcePlayerIndex: null,
        player: null,
      },
      dragOverModerator: false,
      dragOverGroupIndex: null,
      DetectiveHatIcon,
      UserIcon
    };
  },
  computed: {
    $style() {
      return styles;
    },
    $pgCTStyle() {
      return playGameComponentsTemplateStyles;
    },
    displayTotalPlayers() {
      // exclude only host
      return this.players.filter(
        p => p.role !== "host"
      ).length;
    },
    displayGroups() {
      return this.phase === "JOIN"
        ? this.localGroups
        : this.groups;
    },
    moderatorPlayers() {
      console.log("ALL PLAYERS", this.players);
      return this.players.filter(
        p => this.isModeratorAnywhere(p.id)
      );
    },
    showModeratorSection() {
      return (
        this.phase === 'JOIN' ||
        (
          this.moderatorPlayers.length > 0 &&
          (
            this.isModeratorView ||
            Number(this.hostId) > 0
          )
        )
      );
    }
  },
  watch: {
    groups: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.localGroups = (newVal || []).map((group, index) => ({
          id: group.id || `temp-${index + 1}`,
          name: group.name || this.$t("group-label", { id: index + 1 }),
          players: [...(group.players || [])],
        }));
      },
    },
  },
  methods: {
    isPlayerModerator(playerId) {
      return this.isModeratorAnywhere(playerId);
    },
    isDraggingPlayer(playerId) {
      return Number(this.dragState.player?.id) === Number(playerId);
    },
    handleGroupLeave(event) {
      if (event.currentTarget.contains(event.relatedTarget)) {
        return;
      }

      this.dragOverGroupIndex = null;
    },
    handleModeratorDrop() {
      if (this.phase !== "JOIN") return;
      const {
        sourceGroupIndex,
        sourcePlayerIndex,
        player
      } = this.dragState;
      if (
        sourceGroupIndex === null ||
        sourcePlayerIndex === null ||
        !player
      ) {
        return;
      }
      // make moderator
      this.toggleModeratorAllGroups(player.id);
      this.dragOverModerator = false;
      this.handleDragEnd();
    },
    getModeratorButtonIcon(playerId) {
      return this.isModeratorAnywhere(playerId)
        ? this.DetectiveHatIcon
        : this.UserIcon;
    },
    isModerator(groupIndex, playerId) {
      const pid = Number(playerId);
      if (this.pendingModerators?.[pid]?.length) {
        return true;
      }
      const player =
        this.players.find(
          p => Number(p.id) === pid
        );
      const existingGroups =
        player?.moderatorGroupIds ||
        player?.moderator_group_ids ||
        [];
      const sourceGroups = this.displayGroups;
      return existingGroups.includes(
        Number(sourceGroups[groupIndex]?.id)
      );
    },
    isModeratorAnywhere(playerId) {
      const pid = Number(playerId);
      const pendingGroups = this.pendingModerators?.[pid] || [];
      const player = this.players.find(
        p => Number(p.id) === pid
      );
      const existingGroups =
        player?.moderatorGroupIds ||
        player?.moderator_group_ids ||
        [];
      return (
        pendingGroups.length > 0 ||
        existingGroups.length > 0 ||
        player?.role === "moderator"
      );
    },
    handleModeratorDragStart(player) {
      if (this.phase !== "JOIN") return;
      const sourceGroupIndex = this.localGroups.findIndex(group =>
        group.players.some(p => Number(p.id) === Number(player.id))
      );
      if (sourceGroupIndex === -1) return;
      const sourcePlayerIndex =
        this.localGroups[sourceGroupIndex].players.findIndex(
          p => Number(p.id) === Number(player.id)
        );
      this.dragState = {
        sourceGroupIndex,
        sourcePlayerIndex,
        player,
      };
    },
    emitGroups() {
      this.$emit(
        "update:groups",
        this.localGroups.map((group, index) => ({
          id: group.id || `temp-${index + 1}`,
          name: group.name || this.$t("group-label", { id: index + 1 }),
          players: [...group.players],
        }))
      );
    },

    handleDragStart(groupIndex, player) {
      if (this.phase !== "JOIN") return;
      const actualPlayerIndex =
        this.localGroups[groupIndex]?.players.findIndex(
          p => Number(p.id) === Number(player.id)
        );
      if (actualPlayerIndex === -1) return;
      this.dragState = {
        sourceGroupIndex: groupIndex,
        sourcePlayerIndex: actualPlayerIndex,
        player,
      };
    },

    handleDragEnd() {
      this.dragState = {
        sourceGroupIndex: null,
        sourcePlayerIndex: null,
        player: null,
      };
      this.dragOverGroupIndex = null;
      this.dragOverModerator = false;
    },

    handleGroupDrop(targetGroupIndex) {
      if (this.phase !== "JOIN") return;
      const { sourceGroupIndex, sourcePlayerIndex, player } = this.dragState;
      if (
        sourceGroupIndex === null ||
        sourcePlayerIndex === null ||
        !player
      ) {
        return;
      }
      if (sourceGroupIndex === targetGroupIndex && !this.isModeratorAnywhere(player.id)) {
        return;
      }
      const sourceGroup = this.localGroups[sourceGroupIndex];
      const targetGroup = this.localGroups[targetGroupIndex];
      if (!sourceGroup || !targetGroup) return;
      const alreadyExists = targetGroup.players.some(
        (p) => Number(p.id) === Number(player.id)
      );
      let updatedModerators = { ...this.pendingModerators };
      if (this.isModeratorAnywhere(player.id)) {
        delete updatedModerators[Number(player.id)];
      }
      /*
        If moderator is dropped into the same/original group,
        do not move the player because they already exist there.
        Just demote.
      */
      if (alreadyExists) {
        this.cleanupModerators(updatedModerators);
        this.emitGroups();
        this.$nextTick(() => {
          this.dragOverGroupIndex = null;
        });
        return;
      }
      sourceGroup.players.splice(sourcePlayerIndex, 1);
      targetGroup.players.push(player);
      this.cleanupModerators(updatedModerators);
      this.emitGroups();
      this.$nextTick(() => {
        this.dragOverGroupIndex = null;
      });
    },
    handlePlayerDrop(targetGroupIndex) {
      if (this.phase !== "JOIN") return;
      const {
        sourceGroupIndex,
        sourcePlayerIndex,
        player
      } = this.dragState;

      if (sourceGroupIndex === null || sourcePlayerIndex === null || !player) {
        return;
      }
      const sourceGroup = this.localGroups[sourceGroupIndex];
      const targetGroup = this.localGroups[targetGroupIndex];
      if (!sourceGroup || !targetGroup) return;
      const alreadyExists = targetGroup.players.some(
        (p) => Number(p.id) === Number(player.id)
      );
      let updatedModerators = { ...this.pendingModerators };
      // moderator dropped into normal group = demote
      if (this.isModeratorAnywhere(player.id)) {
        delete updatedModerators[Number(player.id)];
      }
      /*
        If player already exists in target group,
        just demote moderator if needed.
      */
      if (alreadyExists) {
        this.cleanupModerators(updatedModerators);
        this.emitGroups();
        this.$nextTick(() => {
          this.dragOverGroupIndex = null;
        });

        return;
      }
      // REMOVE from old group
      sourceGroup.players.splice(sourcePlayerIndex, 1);
      // ADD to new group
      targetGroup.players.push(player);
      this.cleanupModerators(updatedModerators);
      this.emitGroups();
      this.$nextTick(() => {
        this.dragOverGroupIndex = null;
      });
    },
    getModerator(groupIndex) {
      const sourceGroups =this.displayGroups;
      const group = sourceGroups[groupIndex];
      if (!group) return null;
      return (
        group.players.find(
          p => this.isModerator(groupIndex, p.id)
        ) || null
      );
    },
    getNonModeratorPlayers(groupIndex) {
      const sourceGroups = this.displayGroups;
      const group = sourceGroups[groupIndex];
      if (!group) return [];
      return group.players.filter(
        p => !this.isModeratorAnywhere(p.id)
      );
    },
    displayPlayersCount(groupIndex) {
      const sourceGroups = this.displayGroups;
      const group = sourceGroups[groupIndex];
      if (!group) return 0;
      // JOIN → hide moderators from count
      if (this.phase === "JOIN") {
        return group.players.filter(
          p => !this.isPlayerModerator(p.id)
        ).length;
      }
      // READ+ → moderators excluded
      return this.getNonModeratorPlayers(groupIndex).length;
    },
    displayPlayers(groupIndex) {
      const sourceGroups =this.displayGroups;
      const group = sourceGroups[groupIndex];
      if (!group) return [];
      // ALWAYS hide moderators from normal groups
      return group.players.filter(
        p => !this.isModeratorAnywhere(p.id)
      );
    },
    cleanupModerators(moderators = this.pendingModerators) {
      const updatedModerators = {
        ...moderators
      };
      Object.entries(updatedModerators).forEach(
        ([pid, groupIndexes]) => {

          const playerStillExists = this.localGroups.some(
            group =>
              group.players.some(
                p => Number(p.id) === Number(pid)
              )
          );
          if (!playerStillExists) {
            delete updatedModerators[pid];
            return;
          }
          updatedModerators[pid] =
            groupIndexes.filter(gid => {
              return this.localGroups[gid];
            });

          if (!updatedModerators[pid].length) {
            delete updatedModerators[pid];
          }
        }
      );
      this.$emit(
        "update:moderators",
        updatedModerators
      );
    },
    toggleModeratorAllGroups(playerId) {
      const updated = { ...this.pendingModerators };
      const pid = Number(playerId);

      if (updated[pid]?.length) {
        delete updated[pid];
      } else {
        updated[pid] = this.localGroups.map((_, idx) => idx);
      }

      this.$emit("update:moderators", updated);
    },
  },
};
</script>

<style scoped>
.emptyDropZone {
  min-height: 48px;
  border: 1px dashed #bdbdbd;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 8px;
  font-size: 14px;
  color: #666;
}

.draggingPlayer {
  opacity: 0.6;
}
</style>